import {Tab} from "semantic-ui-react";
import * as React from "react";
import {QueuesEditPage} from "./queues/QueueEditPage";
import {QueuedEventsPage} from "./events/QueuedEventsPage";
import {QueuedEventsErrorPage} from "./error/QueuedEventsErrorPage";
import {authentication} from "../../../../authentication";
import {EtaCalculatorEventExplorer} from "./eta/EtaCalculatorEventExplorer";
import {clampTabIndex} from "../../context/TabSession";

const panes = (props: any) => [
    {menuItem: 'Events', render: (_: any) => <Tab.Pane><QueuedEventsPage history={props.history}/></Tab.Pane>},
    {menuItem: 'Queues', render: (_: any) => <Tab.Pane><QueuesEditPage history={props.history}/></Tab.Pane>},
]

const panesForSuperusers = (props: any) => [
    {menuItem: 'Events', render: (_: any) => <Tab.Pane><QueuedEventsPage history={props.history}/></Tab.Pane>},
    {menuItem: 'Error', render: (_: any) => <Tab.Pane><QueuedEventsErrorPage/></Tab.Pane>},
    {menuItem: 'Queues', render: (_: any) => <Tab.Pane><QueuesEditPage history={props.history}/></Tab.Pane>},
    {menuItem: 'ETA Calculator', render: (_: any) => <Tab.Pane><EtaCalculatorEventExplorer/></Tab.Pane>},
]

function panesForRole(props?: any) {
    if (authentication.isSuperUser) {
        return panesForSuperusers(props)
    } else {
        return panes(props)
    }
}

const QueuesTabView = (props: any) => <Tab
    id={"QueuesTabView"}
    className={"flexTab"}
    {...props = props}
    panes={panesForRole(props)}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.queuesTab, panesForRole(props))}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("queuesTab", data.activeIndex)
    }}
/>

export default QueuesTabView